import { User } from '../types/User';
import { apiClient } from './client';

export interface LoginResponse {
    success: boolean;
    token: string;
    user: User;
}
export const loginApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<
            LoginResponse,
            { mobile: string; password: string }
        >({
            query: (credentials) => ({
                url: '/api/auth/login',
                method: 'POST',
                body: credentials,
            }),
        }),
    }),
});

export const { useLoginMutation } = loginApi;
export default loginApi;
